// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1ejb{width:var(--ds-space-300,24px)}
._ahbqpxbi{margin-inline-start:var(--ds-space-200,1pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/empty-state/dist/esm/styled/spinner-container.compiled.css"],"names":[],"mappings":"AAAA,WAAW,8BAA8B;AACzC,WAAW,2CAA2C","sourcesContent":["._1bsb1ejb{width:var(--ds-space-300,24px)}\n._ahbqpxbi{margin-inline-start:var(--ds-space-200,1pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
